import { Controller } from "stimulus";
import * as basicLightbox from "basiclightbox";

export default class extends Controller {
  connect() {
    if (location.hash && location.hash === `#${this.element.id}`) {
      this.show();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }
  }

  disconnect() {
    delete this.modal;
  }

  show(event) {
    if (event) event.preventDefault();

    this.modal ||= basicLightbox.create(`
      <img src="${this.element.href}" width="100vw" height="100vh">
    `);

    this.modal.show();
  }
}
